import React from 'react';
import './Home.css';
import HeroSection from '../components/Home/HeroSection';
import ChannelsSection from '../components/Home/ChannelsSection';
import NewsletterSection from '../components/Home/NewsletterSection';
import ReportsSection from '../components/Home/ReportsSection';
//import Footer from '../components/Home/Footer';

function Home() {
  return (
    <div className="home-page" >
      <HeroSection />
      <ChannelsSection />
      <ReportsSection />
      <NewsletterSection />
    </div>
  );
}

export default Home;
